module.exports = __webpack_public_path__ + "static/media/varie4.48754ce1.jpg";